export default "__VITE_ASSET__BQLK4XGu__ 640w, __VITE_ASSET__BtxCuEr3__ 1024w, __VITE_ASSET__CSHfIeE3__ 1536w";